import { Input } from "nlib/ui";
import Money from "utils/Money";
import React, { useCallback } from "react";

const MoneyInput = ({ value, currency, onChange, ...props }) => {
  const handleChange = useCallback((newValue) => {
    onChange(newValue && Money.toMoneyNumber(newValue || 0, true, Money.getCurrencyPrecision(currency)));
  }, [currency, onChange]);

  return (
    <Input
      {...props}
      type="number"
      step="any"
      value={value}
      onChange={handleChange} />
  );
};

export default React.memo(MoneyInput);
